import PropTypes from 'prop-types'
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionIcon,
  AccordionPanel,
  Box,
  Icon,
  StackDivider,
  Flex,
  Stack,
} from '@chakra-ui/react'

const Row = ({item}) => {
  if (item.extendedDescription) {
    return (
      <Accordion allowToggle>
        <AccordionItem border="none">
          <AccordionButton
            data-testid={`sandwich-item-${item.key}`}
            px={0}
            py={1}
          >
            <Icon as={item.icon} boxSize="4" />
            <Box flex={1} ml={3} textAlign="left">
              {item.description}
            </Box>
            {item.extendedDescription && <AccordionIcon boxSize="5" />}
          </AccordionButton>
          {item.extendedDescription && (
            <AccordionPanel pb={2} pt={1} pl={7}>
              {item.extendedDescription}
            </AccordionPanel>
          )}
        </AccordionItem>
      </Accordion>
    )
  }

  return (
    <Flex
      data-testid={`sandwich-item-${item.key}`}
      key={item.key}
      direction="row"
      align="center"
      gap={3}
      py={1}
    >
      <Icon as={item.icon} boxSize="4" />
      <Box flex={1}>{item.description}</Box>
    </Flex>
  )
}

Row.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
    description: PropTypes.node.isRequired,
    extendedDescription: PropTypes.node,
  }).isRequired,
}

const SandwichInformationList = ({data, ...props}) => {
  return (
    <Box {...props}>
      <Stack
        divider={<StackDivider borderColor="mld.neutral.500" />}
        spacing={2}
        align="stretch"
        background="mld.neutral.50"
        px={3}
        py={2}
      >
        {data.map((item) => (
          <Row key={item.key} item={item} />
        ))}
      </Stack>
    </Box>
  )
}

SandwichInformationList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      icon: PropTypes.elementType.isRequired,
      description: PropTypes.node.isRequired,
      extendedDescription: PropTypes.node,
    }),
  ).isRequired,
}

export default SandwichInformationList
